<div
  [formGroup]="form"
  [attr.data-test-id]="'wrap-' + fieldAttribute.elementDataTestId"
  [ngClass]="fieldAttribute.elementStyles.containerStyle"
>
  <label class="form-label" [for]="fieldAttribute.id" [ngClass]="fieldAttribute.elementStyles.labelStyle">
    {{ fieldAttribute.backendAttribute.label | translate }}
    <span *ngIf="fieldAttribute.backendAttribute.required">*</span>
  </label>
  <div #selectedMenu="ngbDropdown" ngbDropdown>
    <button
      type="button"
      (click)="selectedMenu.isOpen() ? selectedMenu.close() : selectedMenu.open()"
      class="dropdown-button border-0 w-100 p-0"
    >
      <input
        #dropDown
        [id]="fieldAttribute.id"
        class="disabled-dropdown"
        type="text"
        [class.is-invalid]="isFieldInvalid()"
        [ngClass]="fieldAttribute.elementStyles.contentStyle"
        [formControlName]="fieldAttribute.backendAttribute.name"
        [attr.data-test-id]="fieldAttribute.elementDataTestId"
        ngbDropdownAnchor
        readonly
        [value]="selectedItem"
        [placeholder]="fieldAttribute.backendAttribute.placeholder | translate"
      />
    </button>
    <div ngbDropdownMenu aria-labelledby="dropdownManual">
      <ng-container *ngFor="let item of fieldAttribute.options; index as i">
        <button
          [attr.data-test-id]="'option-' + fieldAttribute.elementDataTestId + i"
          class="dropDownMenu"
          type="button"
          ngbDropdownItem
          [value]="item.entity_id"
          (click)="selectCurrentValue(item)"
        >
          {{ item.title | translate }}
        </button>
      </ng-container>
    </div>
  </div>
  <small
    *ngIf="form.get(fieldAttribute.backendAttribute.name) && form.get(fieldAttribute.backendAttribute.name).invalid"
    class="d-flex mt-1 invalid-feedback"
    [attr.data-test-id]="fieldAttribute.errorDataTestId"
  >
    {{ getValidationError(form.get(fieldAttribute.backendAttribute.name)) | translate }}
  </small>
</div>
